import { EXAMPLE_IDS, TIP_IDS, useDocsContent } from "./content";
import { DocSubheading, EntryList, RichText } from "./doc-parts";

/**
 * What to ask: read-only access to Odoo in plain words, example questions and
 * tips on asking well. The tools Claude uses for it are the next page.
 */
export function AskPage() {
  const { capabilities: text } = useDocsContent();
  const [openQuote, closeQuote] = text.quotes;
  return (
    <>
      <p>
        <RichText text={text.intro} />
      </p>

      <DocSubheading>{text.examplesHeading}</DocSubheading>
      <ul className="space-y-2">
        {EXAMPLE_IDS.map((id) => (
          <li key={id} className="bg-accent-light rounded-md px-3 py-2">
            {openQuote}
            {text.examples[id]}
            {closeQuote}
          </li>
        ))}
      </ul>
      <p className="text-muted">{text.examplesNote}</p>

      <DocSubheading>{text.tipsHeading}</DocSubheading>
      <EntryList ids={TIP_IDS} entries={text.tips} />
    </>
  );
}
